import axios from "axios"
import { Box, Text } from "grommet"
import { FilePond } from "react-filepond"
import fr_FR from "filepond/locale/fr-fr.js"
import { SharepointUrl } from "./SharepointValuePair.jsx"

function MediaTab({ item, resourcePath }) {
    return (
        <Box pad={{ vertical: "medium" }}>
            <FilePond
                allowMultiple={true}
                allowRevert={false}
                onactivatefile
                maxFileSize="1000MB"
                {...fr_FR}
                server={{
                    url: `${process.env.REACT_APP_API_BASE_URL}/${resourcePath}/${item.id}/medias`,
                    process: (fieldName, file, _x, load, error, _y, abort) => {
                        const controller = new AbortController()
                        const formData = new FormData()

                        formData.append(fieldName, file)
                        formData.append("name", file.name)

                        axios
                            .post(`/${resourcePath}/${item.id}/medias`, formData, {
                                signal: controller.signal,
                            })
                            .then(() => {
                                load()
                            })
                            .catch(() => {
                                error()
                            })

                        return {
                            abort: () => {
                                controller.abort()
                                abort()
                            },
                        }
                    },
                }}
                name="media"
            />

            <Text>
                Une fois téléchargée, l'image ne s'affiche plus dans cette zone.
                Vous retrouverez les images précédemment téléchargées dans le Sharepoint.
            </Text>

            <SharepointUrl url={item.getDriveFolderUrl()} />
        </Box>
    )
}

export { MediaTab }